export default __webpack_public_path__ + "static/media/cat2-2-1.9d8d15c3.jpg";